<script setup>
import { computed } from 'vue';
import FilterButton from 'dashboard/components/ui/Dropdown/DropdownButton.vue';
import FilterListDropdown from 'dashboard/components/ui/Dropdown/DropdownList.vue';
import FilterListItemButton from 'dashboard/components/ui/Dropdown/DropdownListItemButton.vue';

const props = defineProps({
  type: {
    type: String,
    default: 'ratings',
  },
  selectedIds: {
    type: Array,
    default: () => [],
  },
  options: {
    type: Array,
    default: () => [],
  },
  activeFilterType: {
    type: String,
    default: '',
  },
  showMenu: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['toggleDropdown', 'closeDropdown', 'toggleFilter']);

const isSelected = id => props.selectedIds.includes(id);

const buttonText = computed(() => {
  const selectedNames = props.options
    .filter(option => isSelected(option.id))
    .map(option => option.name);
  return selectedNames.length ? selectedNames.join(', ') : props.placeholder;
});

const toggleDropdown = () => emit('toggleDropdown', props.type);
const closeDropdown = () => emit('closeDropdown');
const toggleFilter = item => emit('toggleFilter', item.id);
</script>

<template>
  <FilterButton
    trailing-icon
    icon="i-lucide-chevron-down"
    :button-text="buttonText"
    @click="toggleDropdown"
  >
    <template v-if="showMenu && activeFilterType === type" #dropdown>
      <FilterListDropdown
        v-on-clickaway="closeDropdown"
        class="flex flex-col w-[240px] overflow-y-auto left-0 md:left-auto md:right-0 top-10"
      >
        <template #listItem>
          <FilterListItemButton
            v-for="item in options"
            :key="item.id"
            :is-active="isSelected(item.id)"
            :button-text="item.name"
            @click.stop.prevent="toggleFilter(item)"
          />
        </template>
      </FilterListDropdown>
    </template>
  </FilterButton>
</template>
